import React from 'react';
import { Section } from './ui/Section';
import { XCircle } from 'lucide-react';
export function WhyItFailed() {
  const items = [{
    title: 'Terapia',
    desc: 'Te ayudó a entender. No a elegir distinto.'
  }, {
    title: 'Amor propio',
    desc: 'Te hizo sentir mejor. No cambiar tu patrón.'
  }, {
    title: 'Manifestación',
    desc: 'Te dio esperanza. No resultados.'
  }];
  return <Section className="bg-[#FAF8F5]" data-id="element-139">
      <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-[#2D2D2D] mb-12" data-id="element-140">
        Por qué lo que probaste falló
      </h2>

      <div className="grid md:grid-cols-3 gap-6" data-id="element-141">
        {items.map((item, idx) => <div key={idx} className="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-[#D4735E]/10" data-id="element-142">
            <div className="flex items-center gap-3 mb-4" data-id="element-143">
              <XCircle className="w-6 h-6 text-[#D4735E]" data-id="element-144" />
              <h3 className="text-xl font-bold text-[#2D2D2D]" data-id="element-145">{item.title}</h3>
            </div>
            <p className="text-[#666666] leading-relaxed" data-id="element-146">{item.desc}</p>
          </div>)}
      </div>
    </Section>;
}